module.exports = __webpack_public_path__ + "static/media/ios-filing.a7d2de58.svg";